import React from "react";

const KeywordsModal = ({ blog, onClose }) => {
    const keywords = blog?.keywords || [];
    console.log(keywords);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-full max-w-2xl p-6">
                <h2 className="text-xl font-bold mb-4">Keywords</h2>
                <div className="mb-4">
                    {keywords.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                            {keywords.map((keyword, index) => (
                                <span
                                    key={index}
                                    className="bg-primary-100 text-primary px-3 py-1 rounded-full text-sm"
                                >
                                    {keyword}
                                </span>
                            ))}
                        </div>
                    ) : (
                        <p className="text-gray-500">No keywords available</p>
                    )}
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default KeywordsModal;

